module.exports = __webpack_public_path__ + "img/332x454px.77664a66.png";